// extracted by mini-css-extract-plugin
var _1 = "active-media-preview";
var _2 = "base-link";
var _3 = "#000000";
var _4 = "#76F366";
var _5 = "#EB8632";
var _6 = "#ECC834";
var _7 = "#21FC87";
var _8 = "#EA4A30";
var _9 = "#C7EA45";
var _a = "#272B2B";
var _b = "#BDBDBD";
var _c = "#7D7D7D";
var _d = "#6A0DAD";
var _e = "#3A65FF";
var _f = "#4A90E2";
var _10 = "#ffffff";
var _11 = "fancyTextArea";
var _12 = "fancyTextAreaDisabled";
var _13 = "fancyTextAreaError";
var _14 = "fancyTextAreaSuccess";
var _15 = "form-control-wrapper";
var _16 = "reset-button";
var _17 = "1200px";
var _18 = "992px";
var _19 = "1366px";
var _1a = "768px";
var _1b = "1475px";
var _1c = "576px";
var _1d = "1600px";
var _1e = "320px";
var _1f = "2500px";
var _20 = "single-page-responsive-font-size";
export { _1 as "active-media-preview", _2 as "base-link", _3 as "colorBlack", _4 as "colorGradeEX", _5 as "colorGradeFR", _6 as "colorGradeGD", _7 as "colorGradeOU", _8 as "colorGradePR", _9 as "colorGradeVG", _a as "colorNeutral", _b as "colorNeutralLighest", _c as "colorNeutralLight", _d as "colorNonOwnerSweetLine", _e as "colorOwnerSweetLine", _f as "colorRegularLinks", _10 as "colorWhite", _11 as "fancyTextArea", _12 as "fancyTextAreaDisabled", _13 as "fancyTextAreaError", _14 as "fancyTextAreaSuccess", _15 as "form-control-wrapper", _16 as "reset-button", _17 as "screenlg", _18 as "screenmd", _19 as "screenml", _1a as "screensm", _1b as "screenxlg", _1c as "screenxs", _1d as "screenxxlg", _1e as "screenxxs", _1f as "screenxxxlg", _20 as "single-page-responsive-font-size" }
export default { "active-media-preview": _1, "base-link": _2, "colorBlack": _3, "colorGradeEX": _4, "colorGradeFR": _5, "colorGradeGD": _6, "colorGradeOU": _7, "colorGradePR": _8, "colorGradeVG": _9, "colorNeutral": _a, "colorNeutralLighest": _b, "colorNeutralLight": _c, "colorNonOwnerSweetLine": _d, "colorOwnerSweetLine": _e, "colorRegularLinks": _f, "colorWhite": _10, "fancyTextArea": _11, "fancyTextAreaDisabled": _12, "fancyTextAreaError": _13, "fancyTextAreaSuccess": _14, "form-control-wrapper": _15, "reset-button": _16, "screenlg": _17, "screenmd": _18, "screenml": _19, "screensm": _1a, "screenxlg": _1b, "screenxs": _1c, "screenxxlg": _1d, "screenxxs": _1e, "screenxxxlg": _1f, "single-page-responsive-font-size": _20 }
